export default "__VITE_ASSET__Dl0SKlhy__"